import { __ } from '@wordpress/i18n';

import {
	__experimentalToolsPanelItem as ToolsPanelItem,
} from '@wordpress/components';

/**
 * Checks if the block's parent is a row.
 * @param {string} clientId Block ID in the Editor.
 * @returns 
 */
const isParentBlockRow = (clientId) => {
	const parentBlockID = wp.data.select('core/block-editor').getBlockParentsByBlockName(clientId, ['core/group'], true)[0];
	const parentBlockAttributes = wp.data.select('core/block-editor').getBlockAttributes(parentBlockID);
	const parentBlockName = wp.data.select('core/block-editor').getBlockName(parentBlockID);
	const parentBlockLayout = parentBlockAttributes?.layout?.type;
	const parentBlockOrientation = parentBlockAttributes?.layout?.orientation;
	return parentBlockName === 'core/group' && parentBlockLayout === 'flex' && parentBlockOrientation !== 'vertical' ? true : false;
}

/**
 * Register advanced layout options to the group block.
 */
function registerExtraLayoutOptions(settings, name) {
	if (typeof settings.attributes !== 'undefined') {
		settings.attributes = {
			...settings.attributes,
			layout: {
				...settings.attributes.layout,
				minWidth: {
					type: 'string',
				},
				addFlexGrow: {
					type: 'boolean',
					default: false,
				},
			}
		}
	}

	return settings;
}

wp.hooks.addFilter(
	'blocks.registerBlockType',
	'ebowp/register-advanced-block-options',
	registerExtraLayoutOptions
);


/**
 * Add advanced layout options to the group block.
 * @see https://awhitepixel.com/blog/add-custom-settings-to-existing-wordpress-gutenberg-blocks/
 */
const addExtraLayoutOptions = wp.compose.createHigherOrderComponent((BlockEdit) => {
	return (props) => {

		const { attributes, isSelected, setAttributes, clientId } = props;
		const { Fragment } = wp.element;
		const { InspectorControls, HeightControl } = wp.blockEditor;
		const { ToggleControl } = wp.components;

		return (
			<Fragment>
				<BlockEdit {...props} />

				{isSelected && isParentBlockRow(clientId) &&
					<InspectorControls group="dimensions">
						<ToolsPanelItem
							hasValue={() => !!attributes?.layout?.minWidth}
							isShownByDefault={true}
							panelId={clientId}
						>
							<HeightControl
								label={__("Minimum width", "extra-block-options")}
								value={attributes?.layout?.minWidth}
								onChange={(newMinWidth) => setAttributes({ layout: { ...attributes.layout, minWidth: newMinWidth } })}
							/>
						</ToolsPanelItem>
						<ToolsPanelItem
							hasValue={() => !!attributes?.layout?.addFlexGrow}
							isShownByDefault={true}
							panelId={clientId}
						>
							<ToggleControl
								label={__("Add flex-grow", "extra-block-options")}
								help={__("If enabled, the block will grow to fill the available space.", "extra-block-options")}
								checked={attributes?.layout?.addFlexGrow || false}
								onChange={(newAddFlexGrow) => setAttributes({ layout: { ...attributes.layout, addFlexGrow: newAddFlexGrow } })}
							/>
						</ToolsPanelItem>
					</InspectorControls>

				}
			</Fragment >
		);
	}
}, 'addExtraLayoutOptions')

wp.hooks.addFilter(
	'editor.BlockEdit',
	'ebowp/add-advanced-block-options',
	addExtraLayoutOptions
);

/**
 * Add inline styles to the Editor.
 */
const addInlineEditorStyles = wp.compose.createHigherOrderComponent((BlockListBlock) => {
	return (props) => {
		const { attributes, clientId } = props;

		if (isParentBlockRow(clientId)) {
			const minWidth = attributes?.layout?.minWidth;
			const addFlexGrow = attributes?.layout?.addFlexGrow;
			const blockStyles = {
				minWidth: minWidth ? minWidth : 'auto',
				flexGrow: addFlexGrow ? 1 : 'initial',
			};

			return (
				<BlockListBlock
					{...props}
					wrapperProps={{ style: blockStyles }}
				/>
			);
		}

		return (
			<BlockListBlock {...props} />
		);
	}
}, 'addInlineEditorStyles')

wp.hooks.addFilter(
	'editor.BlockListBlock',
	'ebowp/add-inline-editor-styles',
	addInlineEditorStyles
);

// TBD: apply wrap-detect styles to the front-end
// TBD: add GAP support
// TBD: add options for Grid block